<template>
  <div class="container">
    <header class="header">
      <div class="row">
        <div class="col-sm-4">
          <img src="https://www.augenzentrum-zimmermann.de/wp-content/uploads/logo-1.jpg"
               class="standard-logo">
        </div>
        <div class="col-sm">
          <b-nav pills align="right">
            <b-nav-item><router-link to="/">Home</router-link></b-nav-item>
            <b-nav-item-dropdown
              id="my-nav-dropdown"
              text="Kurse"
              toggle-class="nav-link-custom"
              right
            >
              <b-dropdown-item><router-link to="/appointments/Phako">Phako</router-link></b-dropdown-item>
              <b-dropdown-item><router-link to="/appointments/Simulator">Simulator</router-link></b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div class="slider-visibility"> </div>
      </div>
    </header>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import { Vue } from 'vue-property-decorator'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'Header'
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #018CCDFF;
}

header {
  background-color: #ffffff;
  color: #018CCDFF;
  box-sizing: border-box;
  padding-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 20px;
  position: relative;
}

div.slider-visibility{
  height: 0px;
  position: relative;
  width: 100%;
  border-bottom: 1px solid #c5b7bb;
  margin-top: 5px;
}

img.standard-logo {
  aspect-ratio: auto 212 / 100;
  display: inline;
  height: 100px;
  max-height: 100px;
  max-width: 100%;
}
</style>
